// extracted by mini-css-extract-plugin
module.exports = {"wealthContainer":"WealthDisplay_wealthContainer__1vzqL","value":"WealthDisplay_value__1Qcd0"};